import styles from './index.module.css'
import { Tooltip } from '@appkit4/react-components/tooltip'
import classnames from 'classnames'

export const View = ({ content, trigger, position, isDark, children, className, ...props }) => {
    const darkClassName = isDark ? styles.dark : ''

    return (
        <Tooltip
            content={content}
            trigger={trigger}
            position={position}
            className={classnames(styles.default, darkClassName, className)}
            {...props}
        >
            {children}
        </Tooltip>
    )
}
